import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EndPointService } from './end-point.service';

@Injectable({
  providedIn: 'root',
})
export class RouteLogService {
  private _baseUrl = '/api/route/';
  private _logRouteClient = 'log';

  public constructor(private _endPointService: EndPointService) {
    this._endPointService.registerEndPoint(
      'route_log',
      `${this._baseUrl}${this._logRouteClient}`,
      false
    );
  }

  public LogClientRoute(route: string): Observable<void> {
    const param: string[] = [];
    param.push(route);
    return this._endPointService.call<void>('route_log', param, false);
  }
}
